import { useQuery } from '@tanstack/react-query'

import { queries } from '~/features/auth/utils'

const useGetAuthSessionQuery = (enabled?: boolean) => {
  return useQuery({
    ...queries.authSession(),
    enabled,
    refetchOnWindowFocus: 'always',
  })
}

export default useGetAuthSessionQuery
